import { Component } from '@angular/core';
import { SharedService } from '../../../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FirestoreService } from '../../../../services/firestore/firestore.service';
import { CommonModule } from '@angular/common';
import { UserDto } from '../../../../models/user-dto';
import { AuthServiceService } from '../../../../services/authService/auth-service.service';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-user-list',
  imports: [CommonModule, RouterLink],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css'
})
export class UserListComponent {
  showSpinner = true;
  users: UserDto[] = [];
  
  constructor(
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private firestoreService: FirestoreService,
    private authService: AuthServiceService
  ) {}

  ngOnInit() {
    this.getAllUsers();
  }

  getAllUsers() {
    this.firestoreService.getAll('users').subscribe({
      next: (data) => {
        this.users = data;
        this.showSpinner = false;
      },
      error: (error) => {
        this.showSpinner = false;
      }
    });
  }

  toggleUserStatus(user: UserDto) {
    this.spinner.show();
    this.authService.toggleUserBlock(user.id).subscribe({
      next: () => {
        user.accountLocked = !user.accountLocked; // update local state
        this.sharedService.handleSuccess(`🔄 Benutzer ${user.fullName} ist jetzt ${user.accountLocked ? '🚫 Gesperrt' : '✅ Aktiv'}`)
      },
      error: (err) => {
        this.sharedService.handleError(err, undefined, "❌ Fehler beim Umschalten des Benutzerstatus:");
      }
    });
  }
}